import { PureComponent } from "react";
import componentStyles from "./videos-carousel-desktop-component.scss";
import StoriesSlickCarouselComponent from "/components/core/community/home/stories-slick-carousel/stories-slick-carousel-component";
import ColorfulTitleComponent from "/components/core/colorful-title/colorful-title-component";
import VideoCarouselItemComponent from "/components/core/videos-carousel/video-carousel-item/video-carousel-item-component";
import CarouselRoundArrowComponent from "/components/core/carousel-arrow/carousel-round-arrow-component";
import YoutubeVideoModalComponent from "/components/core/youtube-video-modal/youtube-video-modal-component";
import { YOUTUBE_MODAL_OPEN, YOUTUBE_MODAL_CLOSE } from "/constants/bigbrain-event-types";
import isMobile from "is-mobile";
import { MODAL_BACKGROUND } from "/constants/z-index";

const youtubeModalStyle = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    zIndex: `${MODAL_BACKGROUND}`
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    padding: "0",
    border: "none",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "transparent",
    minWidth: "960px",
    overflow: "visible",
    borderRadius: "4px"
  }
};

export default class VideosCarouselDesktopComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.renderItem = this.renderItem.bind(this);

    this.state = {
      videoId: null,
      videoTitle: null
    };
  }

  componentDidMount() {
    this.isMobile = isMobile();
  }

  renderItem(currentItem, index) {
    return <VideoCarouselItemComponent key={index} data={currentItem} onPlay={this.onPlay} isMobile={this.isMobile} />;
  }

  onPlay(videoId, title) {
    BigBrain("track", YOUTUBE_MODAL_OPEN, { kind: title });
    this.setState({ videoId, videoTitle: title });
  }

  closeModal() {
    const { videoTitle } = this.state;
    BigBrain("track", YOUTUBE_MODAL_CLOSE, { kind: videoTitle });
    this.setState({ videoId: null, videoTitle: null });
  }

  render() {
    const { videos, title } = this.props;
    const { videoId } = this.state;
    const responsive = [
      {
        breakpoint: 1250,
        settings: { slidesToShow: Math.min(2, videos.length) }
      },
      {
        breakpoint: 1150,
        settings: {
          className: "center",
          centerMode: true,
          infinite: false,
          focusOnSelect: true,
          initialSlide: Math.min(1, videos.length), // show second slide initially
          variableWidth: false, // to control showing half cards on the sides
          slidesToShow: Math.min(1, videos.length)
        }
      }
    ];
    return (
      <div className="video-carousel-desktop-component">
        <div className="video-carousel-title">
          <ColorfulTitleComponent text={title} />
        </div>
        <StoriesSlickCarouselComponent
          autoplay={false}
          infinite={false}
          items={videos}
          renderItem={this.renderItem}
          responsive={responsive}
          slidesToShow={Math.min(3, videos.length)}
          slidesToScroll={1}
          dots={false}
          nextArrow={<CarouselRoundArrowComponent />}
          prevArrow={<CarouselRoundArrowComponent />}
          minWidthForCarousel={768}
        />
        <YoutubeVideoModalComponent
          footerText="Simplify the way your team works"
          videoId={videoId}
          minHeight={546}
          isOpen={!!videoId}
          opts={{
            width: 970,
            height: 546,
            playerVars: {
              autoplay: 1,
              rel: 0,
              showinfo: 0
            }
          }}
          onCloseModal={this.closeModal}
          style={youtubeModalStyle}
          withSignup={false}
        />
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

VideosCarouselDesktopComponent.defaultProps = {
  videos: []
};
